import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const API = (typeof window !== "undefined" && window.location ? window.location.origin : process.env.REACT_APP_BACKEND_URL) + "/api";
const authHeader = () => {
  const token = localStorage.getItem("token") || localStorage.getItem("access_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export default function SuperAdminAuditLog() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/super-admin/audit-log?limit=200`, { headers: authHeader() });
        setRows(r.data.audit_log || []);
      } catch (e) {
        toast.error("Failed to load audit log");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="space-y-6" data-testid="super-admin-audit-page">
      <header>
        <h1 className="text-3xl font-semibold tracking-tight">Audit Log</h1>
        <p className="text-sm text-slate-500">Every super-admin action is recorded here.</p>
      </header>
      {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : (
        <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-xs uppercase text-slate-600">
              <tr>
                <th className="px-4 py-2 text-left">When</th>
                <th className="px-4 py-2 text-left">Actor</th>
                <th className="px-4 py-2 text-left">Action</th>
                <th className="px-4 py-2 text-left">Target</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {rows.map((r, i) => (
                <tr key={i} data-testid={`audit-row-${i}`}>
                  <td className="px-4 py-2 text-xs font-mono text-slate-500">{r.created_at?.replace("T", " ").slice(0, 19)}</td>
                  <td className="px-4 py-2 text-slate-700">{r.actor_email}</td>
                  <td className="px-4 py-2 font-mono text-xs">{r.action}</td>
                  <td className="px-4 py-2 text-xs text-slate-500">{r.target_type}/{r.target_id}</td>
                </tr>
              ))}
              {rows.length === 0 && <tr><td colSpan={4} className="px-4 py-8 text-center text-slate-400">No events yet.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
